import type { SxProps, Theme } from '@mui/material/styles';

type DashboardStyleMap = {
    root: SxProps<Theme>
    loadingContainer: SxProps<Theme>
    statCard: SxProps<Theme>
    statCardContent: SxProps<Theme>
    statCardFooter: SxProps<Theme>
    detailButton: SxProps<Theme>
};

export const dashboardStyles: DashboardStyleMap = {
    root: { display: 'flex', flexDirection: 'column', gap: 4 },
    loadingContainer: { display: 'flex', justifyContent: 'center', py: 6 },
    statCard: { border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', '&:hover': { boxShadow: 2 }, transition: 'box-shadow 0.2s' },
    statCardContent: { p: 3, display: 'flex', alignItems: 'center', gap: 2 },
    statCardFooter: { px: 3, py: 1.5, bgcolor: 'grey.50', borderTop: '1px solid', borderColor: 'divider' },
    detailButton: { textTransform: 'none', p: 0 },
};

export const getDashboardCardIconStyles = (color: string): SxProps<Theme> => ({
    width: 48,
    height: 48,
    borderRadius: 1.5,
    bgcolor: color,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
});
